import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-small-menu',
  templateUrl: './small-menu.component.html',
  styleUrls: ['./small-menu.component.scss']
})
export class SmallMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
